module.exports = __webpack_public_path__ + "img/l-hd.f8edb47f.webp";